import { Component, OnInit } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';
import { ciiuCodes } from './ciiu';

@Component({
  selector: 'app-ciiu',
  templateUrl: './app-ciiu.component.html',
})

export class AppCiiuComponent extends FieldComponent implements OnInit {
  ciiuList: any[];
  override start() {
    super.start();
    this.ciiuList = ciiuCodes.map(ciiuItem => ({
      value: ciiuItem.value,
      text: `${ciiuItem.value} - ${ciiuItem.description}`,
    }));
    this.field.setFieldOptions(this.ciiuList);
    this.field.getValue() || this.field.setValue([]);
  }

  filterInput(inputText, option) {
    const { nzLabel, nzValue, nzDisabled, nzHide } = option;
    const ciiuCode = ciiuCodes.find(item => item.value === nzValue);
    return (!nzDisabled && !nzHide && (nzLabel.includes(inputText)
      || nzValue?.toString()?.includes(inputText) || ciiuCode?.description.includes(inputText)));
  }
}
